/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_CommissionInputs */

const cs_form_commission = /** @type {(inputs: Form_CommissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provize`)
};

const en_form_commission = /** @type {(inputs: Form_CommissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commission`)
};

/**
* | output |
* | --- |
* | "Commission" |
*
* @param {Form_CommissionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_commission = /** @type {((inputs?: Form_CommissionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_CommissionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_commission(inputs)
	return cs_form_commission(inputs)
});